<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <user-menu ></user-menu>
      <template slot="links">
        <sidebar-item
            v-for="(item, index) in menu " :key="index"
            :link="item"
            v-show="showMenu(item.accesoId)"
            >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './Extra/MobileMenu.vue'
import UserMenu from './Extra/UserMenu.vue'
import { Loading } from "element-ui"
import Error from "src/util/ErrorControl"
import { mapActions, mapGetters } from 'vuex'



// listarMenu

export default {
    components: {
        TopNavbar,
        ContentFooter,
        DashboardContent,
        MobileMenu,
        UserMenu
    },
    data () {
      return {
        menu:[
            {
                name:"Usuarios",
                icon:"mdi-account-cog-outline",
                path:"/admin/usuarios",
                accesoId:0
            },
            {
                name:"Ver Egresos",
                icon:"mdi-clipboard-text-search-outline",
                path:"/egreso/lista",
                accesoId:1
            },
            {
                name:"Cargar Egreso",
                icon:"mdi-file-send-outline",
                path:"/egreso/carga/formulario",
                accesoId:2
            },            {
                name:"Cargar Egreso Excel",
                icon:"mdi-file-excel-outline",
                path:"/egreso/carga/excel",
                accesoId:2
            },
            {
                name:"Ver Multas",
                icon:"mdi-clipboard-text-search-outline",
                path:"/multa/lista",
                accesoId:3
            },
            {
                name:"Cargar Multa",
                icon:"mdi-file-send-outline",
                path:"/multa/carga/formulario",
                accesoId:4
            },            {
                name:"Cargar Multa Excel",
                icon:"mdi-file-excel-outline",
                path:"/multa/carga/excel",
                accesoId:4
            },
            {
                name:"Ver Pagos Vocales",
                icon:"mdi-clipboard-text-search-outline",
                path:"/pago-vocales/lista",
                accesoId:5
            },
            {
                name:"Cargar Pagos Reza",
                icon:"mdi-file-send-outline",
                path:"/pago-vocales/carga/formulario",
                accesoId:9
            },
            {
              name:"Cargar Pago Masivo",
              icon:"mdi-file-excel-outline",
              path:"/pago-vocales/carga/csv",
              accesoId:6
            },
            {
              name:"Envio de Correos",
              icon:"mdi-email-fast-outline",
              path:"/envio-correos",
              accesoId:8
            }


        ]
      }
    },
    async created() {
      let loadingInstance = Loading.service({ fullscreen: true, text: 'Cargando...', background: 'rgba(0, 0, 0, 0.8)' })
      try {
        await this.getUserPerfil();
      } catch (error) {
        console.error('Error al cargar el perfil del usuario:', error);
        // Establecer un perfil vacío con estructura mínima para evitar errores
        this.$store.commit('setUserPerfil', { is_admin: false, accesos: [] });
      } finally {
        loadingInstance.close();
      }
    },
    async mounted(){
    },
    computed: {
      ...mapGetters(["getPerfil"]),
    },
    methods: {
      ...mapActions(["getUserPerfil"]),

        toggleSidebar () {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        },

        showMenu(accesoId){
          console.log('entro al showmenu: accesoId', accesoId);
          // Verificar que getPerfil existe
          if (!this.getPerfil) {
            return false;
          }

          if (accesoId===0) {
            return !!this.getPerfil.is_admin;
          }

          console.log('getPerfil',this.getPerfil);
          // Verificar que accesos existe y es un array antes de usar some
          return this.getPerfil.accesos && Array.isArray(this.getPerfil.accesos) &&
                 this.getPerfil.accesos.some(acceso => acceso.id === accesoId);
        }
    }
}

</script>
